module.exports = __webpack_public_path__ + "media/application/images/transparent_texture-6d252a8ac1c57183dd0d2654290d3ef9.png";